import request from '@/api/clients/portal-client'

// 获取账户流水列表
export function getAccountLogList(params) {
  return request({
    url: '/fin/accountlog/list',
    method: 'POST',
    params
  })
}
